import { render, staticRenderFns } from "./BarreActions.vue?vue&type=template&id=456c325e&"
import script from "./BarreActions.vue?vue&type=script&lang=js&"
export * from "./BarreActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('456c325e')) {
      api.createRecord('456c325e', component.options)
    } else {
      api.reload('456c325e', component.options)
    }
    module.hot.accept("./BarreActions.vue?vue&type=template&id=456c325e&", function () {
      api.rerender('456c325e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Divers/BarreActions.vue"
export default component.exports